import React from 'react';

import { Content } from '../types';

interface ChildrenProps {
  element: Content;
  index: number;
  onChangeContent: (index: number) => void;
}

interface Props {
  content: Content[];
  initialContentName?: string;
  children: (props: ChildrenProps) => React.ReactChild;
}

interface State {
  currentContentIndex: number;
}

class ContentManager extends React.Component<Props, State> {
  state = {
    currentContentIndex: Math.max(
      this.props.content.findIndex(
        el => el.name === this.props.initialContentName,
      ),
      0,
    ),
  };

  handleChangeIndex = (index: number) =>
    this.setState({
      currentContentIndex: index,
    });

  render() {
    const { currentContentIndex } = this.state;

    return this.props.children({
      element: this.props.content[currentContentIndex],
      index: currentContentIndex,
      onChangeContent: this.handleChangeIndex,
    });
  }
}

export { ContentManager };
